import CookieFunctions from "./CookieFunctions";

const globalFunctions = (function () {
    // function to format date
    const formatDate = (passedDate) => {

        var date;

        try {
            date = new Date(passedDate);
        } catch (error) {
            date = new Date();
        }

        var formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? 0 : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? 0 : ""}${date.getDate()} ${date.getHours() < 10 ? 0 : ""}${date.getHours()}:${date.getMinutes() < 10 ? 0 : ""}${date.getMinutes()}`

        return formattedDate;
    }

    // function to check if user is authenticated
    function checkAuthenticated() {
        return CookieFunctions.getJWTToken() != null && CookieFunctions.getJWTToken() !== ""
    }



    return {
        formatDate: formatDate,
        checkAuthenticated: checkAuthenticated
    }

})();

export default globalFunctions;